export default __webpack_public_path__ + "static/media/love.4e8a2041.jpg";